/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import TypeAheadSearchWrapper from './TypeAheadSearch.style';
import { searchUsers } from '../../services/userLookup';


class TypeAheadSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      recipients: [],
      name: '',
      email: '',
      isLoading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleTextInput = this.handleTextInput.bind(this);
  }

  handleChange(evt) {
    if (evt[0]) {
      const lastItem = evt[evt.length - 1];
      // Carry the directory fields through untouched. They are the only
      // trustworthy source for the manager/org/title on the submission, so they
      // must survive selection rather than being reduced to name + email.
      const emailList = evt.map(user => ({
        name: user.fullName,
        email: user.email,
        managerEmail: user.managerEmail,
        org: user.org,
        title: user.title
      }));
      this.setState(
        {
          name: lastItem.fullName,
          email: lastItem.email,
          recipients: emailList
        },
        () => {
          this.props.handleNameEmail(this.state.name, this.state.email, this.state.recipients);
        }
      );
    }
  }

  handleTextInput(evt) {
    if (evt.length > 2) {
      this.setState({
        isLoading: true
      });
      searchUsers(evt)
        .then(users => {
          this.setState({
            data: users,
            isLoading: false
          });
        })
        .catch(err => {
          console.log(err);
          this.setState({
            isLoading: false
          });
        });
    }
  }

  render() {
    const { isLoading } = this.state;
    const options = this.state.data;
    const filterByFields = ['email', 'fullName'];
    return (
      <TypeAheadSearchWrapper>
        <AsyncTypeahead
          id="namesearch"
          inputProps={{ 'aria-label': 'Name Search' }}
          filterBy={filterByFields}
          labelKey="fullName"
          options={options}
          placeholder={this.props.placeholder}
          multiple
          onChange={this.handleChange}
          minLength={3}
          onSearch={this.handleTextInput}
          isLoading={isLoading}
          className="ncss-select-menu"
          renderMenuItemChildren={option => (
            <div>
              {option.fullName}
              <div className="sub-text">{option.email}</div>
            </div>
          )}
        />
      </TypeAheadSearchWrapper>
    );
  }
}

TypeAheadSearch.propTypes = {
  placeholder: PropTypes.string,
  handleNameEmail: PropTypes.func.isRequired,
};

TypeAheadSearch.defaultProps = {
  placeholder: 'Enter name...',
};

export default TypeAheadSearch;


// WEBPACK FOOTER //
// ./src/components/TypeAheadSearch/TypeAheadSearch.js